<template>
  <div id="myPurchase">
    <!--导航栏-->
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      :fixed="true"
      :border="true"
      @click-left="onClickLeft"
      ><template #right>
        <div
          v-if="$route.meta.add"
          name="replay"
          size="18"
          @click="add"
          class="add"
        >
          新增
        </div>
        <van-icon v-else name="replay" size="18" @click="refresh" />
      </template>
    </van-nav-bar>
    <!-- 只缓存供应链列表，保留滚动；详情/入库每次重新进入并拉数 -->
    <keep-alive include="supply-chain">
      <router-view style="padding-top: 46px" />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      title: "采购管理",
      fromRoute: null, // 记录来源路由
    };
  },
  beforeRouteEnter(to, from, next) {
    // 在进入路由前记录来源
    next((vm) => {
      vm.fromRoute = from.path.includes("dashboard/")
        ? from.path
        : localStorage.getItem("fromDashboardRoute");
      localStorage.setItem("fromDashboardRoute", vm.fromRoute);
    });
  },
  watch: {
    $route: {
      handler(to, from) {
        this.title = to.meta.title;
        // console.log(to, "to");
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    add() {
      // 订单 收货 退货
      console.log(this.$router, this.$route);
      let path = "",
        type = "";
      if (this.$route.path.includes("order")) {
        path = "/purchase/orderAdd";
        type = "purchaseOrder";
      } else if (this.$route.path.includes("return")) {
        path = "/purchase/returnAdd";
        type = "purchaseReturn";
      } else if (this.$route.path.includes("receive")) {
        path = "/purchase/receiveAdd";
        type = "purchaseReceive";
      }
      this.$router.push({
        path: path,
        query: { type: type },
      });
    },
    refresh() {
      location.reload();
    },
    onClickLeft() {
      console.log(
        "返回采购页 this.$route.path:",
        this.$route.path,
        "this.$route.meta.prev:",
        this.$route.meta.prev,
        "this.fromRoute:",
        this.fromRoute,'this.$route.meta:',this.$route.meta
      );
      if (this.$route.path.includes("purchase/query")) {
        this.$router.push({ path: "/dashboard/home" });
        return;
      }
      if (this.$route.meta.prev) {
        this.$router.replace(this.$route.meta.prev);
        return;
      }
      if (this.fromRoute && this.$route.meta.returnDashboard) {
        this.$router.push({ path: this.fromRoute });
        return;
      }
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="less">
.van-nav-bar--fixed {
  position: fixed !important;
  z-index: 1000;
}
</style>
